import { Grid, Typography } from "@mui/material";
import { GetUTCTime } from "../../Helpers/GetUTCTime";
import { useDispatch, useSelector } from "react-redux";
import "../../../Assets/Styles/Containers/_button.scss";
import React, { useState, useEffect, useRef, useCallback } from "react";
import "../../../Assets/Styles/Containers/_inspection.scss";
import { convertFontToSpan } from "../../Helpers/HelperFunctions";
import FroalaEditorComponent from "../../Common/HtmlEditor/FroalaEditorComponent";
import { filterSelectTagIntro } from "../LineDetails/CommentDetails/CommentLibraryHelper";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RMLpopup from "./RMLpopup";
import IntroTextMedia from "./IntroTextMedia";
import { getDefaultCategories, saveIntroductoryText } from "../../Redux/Actions/CommonActions";
import uuid from "react-uuid";
import { getCommentLibraryTagList } from "../../Helpers/ApiCall";
import { sanitizeIntroHtmlForDom } from "../../Helpers/IntroTextHtmlHelper";

const froalaConfig = {
  imagePaste: false,
  spellCheck: true,
  heightMin: 201,
  height: 300,
  heightMax: 510,
  linkAutoPrefix: 'https://',
  linkAlwaysBlank: true,
  toolbarButtons: {
    moreText: { buttons: ['bold', 'italic', 'underline', '|', 'fontFamily', 'fontSize', 'textColor', 'backgroundColor'], align: 'left', buttonsVisible: 7 },
    moreParagraph: { buttons: ['|', 'alignLeft', 'alignCenter', 'alignRight', 'formatOLSimple', 'formatUL'], align: 'left', buttonsVisible: 8 },
    moreRich: { buttons: ['|', "insertLink", "outdent", "indent"], align: "left", buttonsVisible: 1 },
    moreMisc: { buttons: ['undo', 'redo', 'spellChecker', 'selectAll', 'html', 'clearFormatting'], align: 'right', buttonsVisible: 2 }
  },
  toolbarButtonsXS: [['fontFamily', 'fontSize', 'bold', 'italic', 'underline', '|'], ['undo', 'redo']],
  pluginsEnabled: ["wordPaste", "spellChecker", "codeBeautifier", "fontFamily", "fontSize", "colors", "align", "lists", 'paragraphFormat', "link"],
};

const AddIntroText = (props) => {
  const { categoryData: categoryDataProp, templateId, categoryId, } = props;
  const normalizeDropdowns = (raw) => {
    if (Array.isArray(raw)) return raw;
    if (Array.isArray(raw?.introductory_text_dropdowns)) return raw.introductory_text_dropdowns;
    return [];
  };
  const editorRef = useRef();
  const containerRef = useRef();
  const dialogRef = useRef();
  const dispatch = useDispatch();
  const storeData = useSelector((state) => state.CommonReducer);
  const [introductoryDropdowns, setIntroductoryDropdowns] = useState([]);
  const [inspectionResponse, setInspectionResponse] = useState(null);
  let templateIndex = inspectionResponse?.inspectionData?.data?.inspectiontemplates?.findIndex((itm) => itm.template_id === templateId);
  let categoryIndex = inspectionResponse?.inspectionData?.data?.inspectiontemplates[templateIndex]?.categories?.findIndex((itm) => itm.id === categoryId);
  let prevData = inspectionResponse?.inspectionData?.data;
  let templateData = storeData?.inspectionData?.data?.inspectiontemplates?.find((template) => template.template_id === templateId)
  const activeCategoryData =
    templateData?.categories?.find((category) => category.id === categoryId) ??
    categoryDataProp;
  const introductoryText = activeCategoryData?.introductory_text;
  const [isCopy, setIsCopy] = useState(true);
  const isCopyRef = useRef(true);
  const [hasChanges, setHasChanges] = useState(false);
  const hasChangesRef = useRef(false);
  const isFocusedRef = useRef(false);
  const handleIntroSaveRef = useRef(null);
  const handleChangeDropdownRef = useRef(null);
  const introductoryDropdownsRef = useRef([]);
  const changedDropdownIdsRef = useRef(new Set());
  const prevCategoryIdRef = useRef(categoryId);
  const pendingCategoryHydrationRef = useRef(false);
  const [hydrationNonce, setHydrationNonce] = useState(0);
  const [showRMLpopup, setShowRMLpopup] = useState(false);
  const [introTextMedia, setIntroTextMedia] = useState();
  const [isFocused, setIsFocused] = useState(false);
  const [isButtonAdded, setIsButtonAdded] = useState(false);
  const [editorContent, setEditorContent] = useState({
    innerHTML: introductoryText ? introductoryText?.replace(/<([a-zA-Z0-9]+)>\s*<\/\1>\s*/g, "") : "",
    dropdownList: introductoryDropdowns?.length ? introductoryDropdowns : normalizeDropdowns(activeCategoryData?.introductory_text_dropdowns)
  });
  const [tag, setTag] = useState(storeData?.clTag !== undefined ? storeData?.clTag : []);
  useEffect(() => {
    getCommentLibraryTagList(dispatch);
  }, [getCommentLibraryTagList]);

  useEffect(() => {
    async function apiCall() {
      if (templateData?.template_uuid && templateData?.is_narrative_template && activeCategoryData?.uuid) {
        await dispatch(getDefaultCategories(`?category_uuid=${activeCategoryData.uuid}&template_guid=${templateData.template_guid}&is_narrative_template=${templateData.is_narrative_template}`));
      }
    }
    apiCall().catch(() => {});
  }, [getDefaultCategories, templateData, categoryId, activeCategoryData?.uuid])

  useEffect(() => {
    setTag(storeData?.clTag !== undefined ? storeData?.clTag : []);
  }, [storeData?.clTag]);
  const markIntroLocalEdit = useCallback(() => {
    hasChangesRef.current = true;
    setHasChanges(true);
    setIsCopy(false);
  }, []);

  const handleChange = (name, content) => {
    if (isButtonAdded) {
      setIsButtonAdded(false);
      return;
    }
    setEditorContent(prevState => ({ ...prevState, innerHTML: content?.replace(/<([a-zA-Z0-9]+)>\s*<\/\1>\s*/g, "") }));
    setHasChanges(true);
    setIsCopy(false);
    setIntroductoryDropdowns(introductoryDropdowns?.length ? introductoryDropdowns : normalizeDropdowns(activeCategoryData?.introductory_text_dropdowns));
  };

  useEffect(() => {
    const categoryChanged = prevCategoryIdRef.current !== categoryId;
    if (categoryChanged) {
      setIsCopy(true);
      setHasChanges(false);
      hasChangesRef.current = false;
      setIntroductoryDropdowns(normalizeDropdowns(activeCategoryData?.introductory_text_dropdowns));
      changedDropdownIdsRef.current.clear();
      return;
    }
     const normalizedText = introductoryText || "";
    setEditorContent({
      innerHTML: normalizedText?.replace(/<([a-zA-Z0-9]+)>\s*<\/\1>\s*/g, ""),
      dropdownList: normalizeDropdowns(activeCategoryData?.introductory_text_dropdowns)
    });
    setIntroductoryDropdowns(normalizeDropdowns(activeCategoryData?.introductory_text_dropdowns));
    changedDropdownIdsRef.current.clear();
  }, [activeCategoryData?.introductory_text_dropdowns, activeCategoryData?.introductory_text, categoryId, introductoryText, setIntroductoryDropdowns]);

  const syncEditorInputValues = useCallback(() => {
    const editorInstance = editorRef?.current?.editor;
    const root = editorInstance?.$el?.get(0);
    if (!root) return;
    root.querySelectorAll("input").forEach((input) => {
      const val = input.value.replace(/"/g, "&quot;").trim();
      input.setAttribute("value", val);
      input.setAttribute("title", val);
    });
  }, []);

  const isEditorInteractionActive = useCallback((editorInstance) => {
    const root = editorInstance?.$el?.get(0);
    if (!root) return false;
    if (isFocusedRef.current) return true;
    const active = document.activeElement;
    if (
      active &&
      root.contains(active) &&
      active.tagName === "INPUT" &&
      (active.closest?.(".froala-dynamic-input-wrapper") ||
        active.classList?.contains("froala-dropdown-input"))
    ) {
      return true;
    }
    if (
      active &&
      root.contains(active) &&
      active.tagName !== "INPUT" &&
      active.tagName !== "SELECT" &&
      active.tagName !== "BUTTON"
    ) {
      return true;
    }
    const sel = window.getSelection();
    if (!sel?.rangeCount) return false;
    const range = sel.getRangeAt(0);
    const container = range.commonAncestorContainer;
    const el = container.nodeType === Node.TEXT_NODE ? container.parentNode : container;
    return !!el && root.contains(el);
  }, []);

  useEffect(() => {
    setIntroTextMedia(activeCategoryData?.introductory_text_media);
  }, [activeCategoryData?.introductory_text_media]);

  useEffect(() => {
    const editorInstance = editorRef?.current?.editor;
    let editorData = activeCategoryData?.introductory_text
    let isEffectExecuted = false;
    let newDropdownList = activeCategoryData?.introductory_text_dropdowns?.length ? [...activeCategoryData?.introductory_text_dropdowns] : [];
    let modifiedHtml;
    const replacePlaceholdersWithDropdowns = () => {
      const rawDropdowns = activeCategoryData?.introductory_text_dropdowns;
      const dropdowns = Array.isArray(rawDropdowns) ? rawDropdowns
        : Array.isArray(rawDropdowns?.introductory_text_dropdowns) ? rawDropdowns.introductory_text_dropdowns
        : [];
      const regexPlainDropdown = /\[a-f0-9\-]+/g;
      // Only strip orphaned markers when we have definitions but none of their uuids appear in the text
      if (dropdowns.length > 0 && !dropdowns.some((dropdown) => activeCategoryData?.introductory_text?.includes(dropdown?.dropdown_uuid))) {
        return activeCategoryData.introductory_text.replace(/\[dropdown\s[^\]]+\]/g, "").trim();
      }
      // When no definitions are loaded yet but the text has [dropdown uuid] markers, render empty inputs
      // so the editor shows the dropdown placeholders rather than blank spaces
      if (!dropdowns.length) {
        const emptyPlaceholderRegex = /\[dropdown\s([a-f0-9-]+)\]/g;
        if (emptyPlaceholderRegex.test(activeCategoryData?.introductory_text)) {
          emptyPlaceholderRegex.lastIndex = 0;
          const baseText = activeCategoryData?.introductory_text.includes("[textbox")
            ? replaceInputs(activeCategoryData?.introductory_text)
            : activeCategoryData?.introductory_text;
          modifiedHtml = baseText.replace(emptyPlaceholderRegex, (match, dropdownId) => {
            const safeId = dropdownId.trim();
            return `<span contenteditable="false" style="white-space: nowrap;" id="dropdown_${safeId}">
              <input type="text" id="${safeId}" class="froala-dropdown-input" value=""
                     placeholder="Type or select from dropdown" autocomplete="off" autocorrect="off" spellcheck="false"
                     style="width: 220px; background-color: #f1f9fe; height: 32px; padding: 4px 8px; vertical-align: middle;
                            border-top: 1px solid #4282e2; border-bottom: 1px solid #4282e2; border-left: 1px solid #4282e2;
                            border-right: none; border-radius: 4px 0px 0px 4px; font-size: 14px; font-weight: 600;
                            color: #3B3B3B; cursor: text; text-align: left; display: inline-block;" />
              <style>.froala-dropdown-input::placeholder { font-style: italic; font-weight: 400; }</style>
              <button contenteditable="false" class="fr-disabled" tabindex="-1" id="dropdownIcon_${safeId}" type="button"
                      data-dropdown-id="${safeId}" onclick="window.openDropdown('${safeId}', event)"
                      style="background-color: #f1f9fe; width: 24px; height: 23px !important; border: 1px solid #4282e2;
                             border-right: 0px; vertical-align: middle; margin-left: -3px; font-size: 14px; color: #4282e2;
                             display: inline-flex; align-items: center; justify-content: center; cursor: pointer;">▾</button>
              <button id="dropdownButton${safeId}" name="${safeId}" class="fr-disabled" contenteditable="false" tabindex="-1"
                      style="background-color: #f1f9fe; width: 24px; height: 23px !important; border: 1px solid #4282e2;
                             border-radius: 0px 4px 4px 0px; margin-left: -3px; font-size: 14px; color: #4282e2;
                             display: inline-flex; align-items: center; justify-content: center; vertical-align: middle; cursor: pointer;">✎</button>
            </span>`;
          });
          return modifiedHtml;
        }
        return activeCategoryData?.introductory_text;
      }
      if (Array?.isArray(dropdowns) && dropdowns?.length > 0) {
        const tempContainer = document.createElement("div");
        const introHtml = activeCategoryData?.introductory_text.includes("[textbox")
          ? replaceInputs(activeCategoryData?.introductory_text)
          : activeCategoryData?.introductory_text;
        tempContainer.innerHTML = sanitizeIntroHtmlForDom(introHtml);
        dropdowns.forEach((dropdown) => {
          let optionValues = [];
          const spanElements = Array.from(tempContainer.querySelectorAll(`span[contenteditable="false"][id="[dropdown ${dropdown?.dropdown_uuid}]"]`));
          if (spanElements?.length > 0) {
            spanElements.forEach((spanElement) => {
              spanElement.innerHTML = "";
              const selectElement = document.createElement("select");
              let newDropdownValues = Array.isArray(dropdown?.dropdowns_values?.values) ? dropdown?.dropdowns_values?.values : dropdown?.dropdowns_values;
              if (Array.isArray(newDropdownValues)) {
                newDropdownValues = newDropdownValues.filter((obj) => !obj.toUpperCase().includes("XXX"));
                if (!newDropdownValues.find((value) => value.includes("------"))) {
                  newDropdownValues.unshift("-------------");
                }
                newDropdownValues.forEach((value) => {
                  const option = document.createElement("option");
                  option.text = value?.length > 40 ? `${value.substring(0, 40)}...` : value || "";
                  option.value = value || "";
                  option.title = value || "";
                  if (dropdown?.selected_value === value) {
                    option.setAttribute("selected", value);
                  }
                  selectElement.appendChild(option);
                });
              }
              selectElement.classList.add(`intro-cl-dropdown`);
              selectElement.setAttribute("id", dropdown.dropdown_uuid);
              selectElement.addEventListener("change", function (event) {
                handleChangeDropdownRef.current?.(event, null);
              });
              optionValues = Array.from(selectElement.options)
                .map((option) => option.value)
                .filter((value) => value !== "-------------");
              newDropdownList.push({
                dropdown_uuid: dropdown.dropdown_uuid,
                name: dropdown?.name || "",
                selected_value: dropdown.selected_value,
                dropdowns_values: optionValues || [],
                isPasted: true,
              });
              spanElement.appendChild(selectElement);
              if (true) {
                const buttonElement = document.createElement("button");
                buttonElement.setAttribute("id", `dropdownButton${dropdown.dropdown_uuid}`);
                buttonElement.setAttribute("contenteditable", "false");
                buttonElement.setAttribute("name", `${dropdown.dropdown_uuid}`);
                buttonElement.classList.add("dropdown-button");
                buttonElement.setAttribute("type", "button");
                buttonElement.style.cssText = `background-color: #f1f9fe;
                      width: 24px;
                      height: 24px;
                      padding: 0px;
                      color: #4282e2;
                      border-radius: 4px 0px 0px 4px;
                      border: 1px solid #4282e2;
                      position: relative;
                      transform: scaleX(-1);
                      font-size: 17px;
                      margin-left: -4px;
                      top: 2px;`;
                buttonElement.textContent = "✎";
                spanElement.appendChild(buttonElement);
              }
              const styleTag = document.createElement("style");
              styleTag.innerHTML = `
                    @media screen and (max-width: 1100px) {
                      #dropdownButton${dropdown.dropdown_uuid} {
                        top: 25.5px;
                      }
                    }
                    @media screen and (min-width: 1600px) {
                      #dropdownButton${dropdown.dropdown_uuid} {
                        top: 2.5px;
                        width: initial;
                        margin-left: -5px;
                      }
                    }
                    @media screen and (min-width: 1700px) {
                      #dropdownButton${dropdown.dropdown_uuid} {
                        top: 2.5px;
                        width: initial;
                        margin-left: -5px;
                      }
                    }
                    @media screen and (min-width: 1800px) {
                      #dropdownButton${dropdown.dropdown_uuid} {
                        top: 2.5px;
                        width: initial;
                        margin-left: -5px;
                      }
                    }
                    @media screen and (min-width: 1900px) {
                      #dropdownButton${dropdown.dropdown_uuid} {
                        top: 2px;
                        width: initial;
                        margin-left: -5px;
                      }
                    }
                    @media screen and (min-width: 2000px) {
                      #dropdownButton${dropdown.dropdown_uuid} {
                        top: 1.5px;
                        width: initial;
                        margin-left: -5px;
                      }
                    }
                    @media screen and (min-width: 2100px) {
                      #dropdownButton${dropdown.dropdown_uuid} {
                        top: 1.5px;
                        width: initial;
                        margin-left: -5px;
                      }
                    }
                  `;
              document.head.appendChild(styleTag);
            });
          } else {
            var placeholderRegex = /\[dropdown\s([a-f0-9-]+)\]/g;
            modifiedHtml = activeCategoryData?.introductory_text?.replace(placeholderRegex, (match, dropdownId) => {
              const dropdown = dropdowns.find((item) => item?.dropdown_uuid === dropdownId);
              if (dropdown) {
                let selectedValue = dropdown?.selected_value
                  ? /^[xX]+$/.test(dropdown.selected_value)
                    ? ""
                    : dropdown.selected_value
                  : "";
                const safeValue = selectedValue.replace(/\\/g, "\\\\").replace(/"/g, "&quot;");
                return `<span contenteditable="false" style="white-space: nowrap;" id="dropdown_${dropdownId}">
                      <input type="text" id="${dropdownId}" class="froala-dropdown-input"
                              value="${safeValue}"
                              placeholder="Type or select from dropdown"
                              autocomplete="off"
                              autocorrect="off"
                              spellcheck="false"
                              style="width: 220px;
                              background-color: #f1f9fe;
                              height: 32px; 
                              padding: 4px 8px;
                              vertical-align: middle;
                              border-top: 1px solid #4282e2;
                              border-bottom: 1px solid #4282e2;
                              border-left: 1px solid #4282e2;
                              border-right: none; 
                              border-radius: 4px 0px 0px 4px; 
                              font-size: 14px;
                              font-weight: 600;
                              color: #3B3B3B;
                              cursor: text;
                              text-align: left;
                              display: inline-block;"
                              />
                               <style>
                              .froala-dropdown-input::placeholder {
                                font-style: italic;
                                font-weight:400;
                                }
                              </style>
                              <button
                                contenteditable="false" 
                                class="fr-disabled"
                                tabindex="-1"
                                id="dropdownIcon_${dropdownId}"
                                type="button"
                                data-dropdown-id="${dropdownId}"
                                onclick="window.openDropdown('${dropdownId}', event)"
                                style="background-color: #f1f9fe;
                                width: 24px;
                                height: 23px !important;
                                border: 1px solid #4282e2;
                               border-right: 0px solid blue;
                                vertical-align: middle;
                                margin-left: -3px;
                                font-size: 14px;
                                color: #4282e2;
                                display: inline-flex;
                                align-items: center;
                                justify-content: center;
                                cursor: pointer;"
                              >
                              ▾
                              </button>
                              ${ true ? `<button id="dropdownButton${dropdownId}" name="${dropdownId}"
                              class="fr-disabled"
                              contenteditable="false" 
                              tabindex="-1"
                              style="background-color: #f1f9fe;
                              width: 24px; 
                              height: 23px !important; 
                              border: 1px solid #4282e2;
                              border-radius: 0px 4px 4px 0px;
                              margin-left:-3px;
                              font-size: 14px;
                              color: #4282e2;
                              display: inline-flex;
                              align-items: center;
                              justify-content: center;
                              vertical-align: middle;
                              cursor: pointer;"
                              >
                                ✎
                              </button>`: ""}
                    </span>`;
              }
              // No definition for this dropdown — render an empty input so it stays interactive
              return `<span contenteditable="false" style="white-space: nowrap;" id="dropdown_${dropdownId}">
                <input type="text" id="${dropdownId}" class="froala-dropdown-input"
                        value=""
                        placeholder="Type or select from dropdown"
                        autocomplete="off"
                        autocorrect="off"
                        spellcheck="false"
                        style="width: 220px;
                        background-color: #f1f9fe;
                        height: 32px;
                        padding: 4px 8px;
                        vertical-align: middle;
                        border-top: 1px solid #4282e2;
                        border-bottom: 1px solid #4282e2;
                        border-left: 1px solid #4282e2;
                        border-right: none;
                        border-radius: 4px 0px 0px 4px;
                        font-size: 14px;
                        font-weight: 600;
                        color: #3B3B3B;
                        cursor: text;
                        text-align: left;
                        display: inline-block;"
                        />
                <style>.froala-dropdown-input::placeholder { font-style: italic; font-weight: 400; }</style>
                <button contenteditable="false" class="fr-disabled" tabindex="-1"
                        id="dropdownIcon_${dropdownId}" type="button"
                        data-dropdown-id="${dropdownId}"
                        onclick="window.openDropdown('${dropdownId}', event)"
                        style="background-color: #f1f9fe; width: 24px; height: 23px !important;
                               border: 1px solid #4282e2; border-right: 0px; vertical-align: middle;
                               margin-left: -3px; font-size: 14px; color: #4282e2;
                               display: inline-flex; align-items: center; justify-content: center; cursor: pointer;">▾</button>
                <button id="dropdownButton${dropdownId}" name="${dropdownId}" class="fr-disabled"
                        contenteditable="false" tabindex="-1"
                        style="background-color: #f1f9fe; width: 24px; height: 23px !important;
                               border: 1px solid #4282e2; border-radius: 0px 4px 4px 0px;
                               margin-left: -3px; font-size: 14px; color: #4282e2;
                               display: inline-flex; align-items: center; justify-content: center;
                               vertical-align: middle; cursor: pointer;">✎</button>
              </span>`;
            });
          }
        });
        editorData = { innerHTML: tempContainer?.innerHTML }
      } else {
        const outputString = editorData?.innerHTML?.replace(regexPlainDropdown, (match, selectId) => {
          return `<select id="${selectId}" class="intro-cl-dropdown"><option>--------------</option></select>`;
        });
        editorData = { innerHTML: outputString }
      }
      return decodeEntities(editorData.innerHTML?.replace(regexPlainDropdown, ""));
    };
    const replaceInputs = (input_text) => {
      let container = document.createElement("div");
      container.innerHTML = input_text;
      container.innerHTML = container.innerHTML.replace(/\[textbox([^\]]*?)\]/g, (match, attributes) => {
        let idMatch = attributes.match(/id:([^;]+);?/);
        let valueMatch = attributes.match(/value:([^;]*);?/);
        let id = idMatch && idMatch[1].trim().length > 30 ? idMatch[1].trim() : uuid();
        let value = valueMatch ? valueMatch[1].trim() : "";
        const safeValue = value.replace(/\\/g, "\\\\").replace(/"/g, "&quot;");
        return `<span contenteditable="false" class="froala-dynamic-input-wrapper"><input id="${id}" value="${safeValue}" title="${safeValue}" style="width: 104px;
                background-color: #f1f9fe;
                height: 24px !important;
                overflow-wrap: break-word;
                padding: 1px 17px 3px 6px;
                border-radius: 4px;
                border: 1px solid #0F75BC;
                appearance: none;
                -webkit-appearance: none;
                -moz-appearance: none;
                font-size: 14px !important;
                color: #3B3B3B !important;
                font-style: normal !important;
                font-weight: 600 !important;
                max-width: 200px !important;
                min-width: 104px !important;
                text-overflow: ellipsis !important;
                white-space: nowrap !important;"
                onblur="handleChangeInput(id, value)"
                /></span>`;
      });
      return container.innerHTML;
    }
    const isIntroTextEmpty =
      activeCategoryData?.introductory_text === "<p></p>" || activeCategoryData?.introductory_text === "";
     setTimeout(async () => {
      const categoryChanged = prevCategoryIdRef.current !== categoryId;
      if (isIntroTextEmpty) {
        if (categoryChanged) prevCategoryIdRef.current = categoryId;
       
          editorInstance?.html?.set("<p></p>");
      }
      else if (activeCategoryData?.introductory_text) {
        if (!isEffectExecuted && (categoryChanged || (isCopyRef.current && !hasChangesRef.current)) && editorInstance) {
          isEffectExecuted = true;
          if (categoryChanged) prevCategoryIdRef.current = categoryId;
          let newHtmlData = replacePlaceholdersWithDropdowns();
          if (activeCategoryData?.introductory_text.includes("[textbox")) {
            if (modifiedHtml) modifiedHtml = replaceInputs(modifiedHtml);
            else if (newHtmlData) newHtmlData = replaceInputs(newHtmlData);
          }
          editorInstance.html.set(modifiedHtml || newHtmlData || "");
          setEditorContent(prevState => ({ ...prevState, innerHTML: modifiedHtml || newHtmlData || "", dropdownList: normalizeDropdowns(activeCategoryData?.introductory_text_dropdowns) }));
        }
      }
    }, 100);

    // Save plain text when editor loses focus entirely (not just moving to toolbar)
    const editorEl = editorInstance?.$el?.get(0);
    const handleEditorBlur = (event) => {
      const froalaBox = editorEl?.closest?.('.fr-box');
      const related = event.relatedTarget;
      if (froalaBox?.contains(related)) return;
      // Opening the "Global lists" / "New list" options dialog (or clicking the
      // add-dropdown / add-input controls) moves focus out of the editor. That is
      // not a real blur-to-save — skip it so a save isn't fired just by opening
      // the dialog.
      if (related?.closest?.("#add-dropdown, #add-input")) return;
      if (dialogRef?.current?.contains?.(related)) return;
      if (dialogRef?.current) return;
      if (hasChangesRef.current) {
        syncEditorInputValues();
        const content = editorInstance?.html?.get();
        if (content !== undefined) {
          const changedDropdowns = introductoryDropdownsRef.current.filter(d => 
            changedDropdownIdsRef.current.has(d.dropdown_uuid)
          );
          // Fire-and-forget: handleIntroSave handles its own errors internally.
          void handleIntroSaveRef.current?.(changedDropdowns.length > 0 ? changedDropdowns : null, null, content);
          setHasChanges(false);
        }
      }
    };
    if (editorEl) {
      editorEl.addEventListener('focusout', handleEditorBlur);
    }

    return () => {
      isEffectExecuted = false;
      if (editorEl) {
        editorEl.removeEventListener('focusout', handleEditorBlur);
      }
    };
  }, [
    categoryId,
    activeCategoryData,
    editorRef,
    syncEditorInputValues,
    hydrationNonce,
  ]);

  useEffect(() => { isCopyRef.current = isCopy; }, [isCopy]);
  useEffect(() => { hasChangesRef.current = hasChanges; }, [hasChanges]);
  useEffect(() => { introductoryDropdownsRef.current = introductoryDropdowns; }, [introductoryDropdowns]);

  const handleIntroSave = useCallback(async (textDropdowns, type = null, data, skipText = false) => {
    try {
      const latestContent = editorRef?.current?.editor?.html?.get();
      const hasDropdowns = Array.isArray(textDropdowns) && textDropdowns.length > 0;
      let dropdownsToSend = textDropdowns || [];
      if (hasDropdowns) {
        const utcTime = await GetUTCTime();
        dropdownsToSend = dropdownsToSend.map(d => ({
          ...d,
          // Normalize name to an empty string so lists without a name are sent
          // as "" instead of null.
          name: d?.name ?? "",
          updated_at: utcTime
        }));
      }

      const inspection_id = storeData?.inspectionData?.data?.inspection_id
        ?? storeData?.inspectionData?.inspection_id;
      const inspection_guid = storeData?.inspectionData?.data?.guid
        ?? storeData?.inspectionData?.guid;
      if (!inspection_id) return;
      if (!activeCategoryData?.uuid) return;

      // Dropdowns can be rendered as <select class="intro-cl-dropdown">, which
      // filterSelectTagIntro does not convert to [dropdown <uuid>] markers.
      // Convert them here first so they survive into the saved text and are
      // counted as referenced dropdowns (otherwise valid dropdowns whose only
      // representation is a <select> would be filtered out of the payload).
      const rawHtml = data ?? latestContent;
      let normalizedHtml = rawHtml;
      try {
        const container = document.createElement("div");
        container.innerHTML = rawHtml || "";
        container.querySelectorAll("select.intro-cl-dropdown[id]").forEach((sel) => {
          const uuid = sel.id?.trim();
          if (uuid) sel.outerHTML = `[dropdown ${uuid}]`;
        });
        normalizedHtml = container.innerHTML;
      } catch (_) {}
      const textContent = filterSelectTagIntro(normalizedHtml);

      // Extract dropdown UUIDs that are referenced in the text
      const textToCheck = textContent || activeCategoryData?.introductory_text || "";
      const dropdownUuidPattern = /\[dropdown\s([a-f0-9-]+)\]/g;
      const referencedDropdownUuids = new Set();
      let match;
      while ((match = dropdownUuidPattern.exec(textToCheck)) !== null) {
        referencedDropdownUuids.add(match[1].trim());
      }

      // Filter dropdowns to only include those referenced in the text
      const filteredDropdowns = dropdownsToSend.length > 0
        ? dropdownsToSend.filter(d => referencedDropdownUuids.has(d.dropdown_uuid))
        : [];

      const fromData = {
        "inspection_id": inspection_id,
        "template_id": templateId,
        "category_uuid": activeCategoryData?.uuid,
        "category_id": categoryId,
        "inspection_guid": inspection_guid,
        ...(!skipText && textContent && { "introductory_text": textContent }),
        ...(filteredDropdowns.length > 0 && { "introductory_text_dropdowns": filteredDropdowns }),
      }

      // Ensure payload has at least one meaningful field (text or dropdowns)
      const hasTextField = 'introductory_text' in fromData;
      const hasDropdownField = 'introductory_text_dropdowns' in fromData;

      // If we have dropdowns but no text, include the existing text
      if (hasDropdownField && !hasTextField) {
        fromData.introductory_text = activeCategoryData?.introductory_text ?? "";
      }
      // If we have neither text nor dropdowns, fallback to existing text to avoid empty payloads
      else if (!hasTextField && !hasDropdownField) {
        fromData.introductory_text =  "";
      }
      await dispatch(saveIntroductoryText(fromData))
    } catch (error) {
      console.error("Failed to save introductory text:", error);
    }
  }, [editorRef, storeData, templateId, activeCategoryData, categoryId, dispatch])

  useEffect(() => { handleIntroSaveRef.current = handleIntroSave; }, [handleIntroSave]);

  const saveIntroText = async () => {
    if (!hasChanges) return;
    syncEditorInputValues();
    const content = editorRef?.current?.editor?.html?.get();
    const changedDropdowns = introductoryDropdownsRef.current.filter(d =>
      changedDropdownIdsRef.current.has(d.dropdown_uuid)
    );
    try {
      await handleIntroSave(changedDropdowns.length > 0 ? changedDropdowns : null, null, content);
    } catch (error) {
      console.error("Failed to save introductory text:", error);
    }
    setIsFocused(false);
  };

  const decodeEntities = (str) => {
    const textArea = document.createElement("textarea");
    textArea.innerHTML = str;
    return textArea.value;
  };

  const escapeRegExp = (str) =>
    String(str ?? "").replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

  const escapeHtmlAttribute = (str) =>
    String(str ?? "").replace(/\\/g, "\\\\").replace(/"/g, "&quot;");

  const handleChangeDropdown = useCallback(async (event, dropdownsParam) => {
    const target = event?.target;
    // "Add input" text fields live inside .froala-dynamic-input-wrapper and must not
    // go through dropdown sync — that path calls html.set() and rebuilds the DOM.
    if (target?.closest?.(".froala-dynamic-input-wrapper")) return;
    if (!target?.classList?.contains("froala-dropdown-input")) return;

    const inputValue = event?.target?.value;
    const truncatedValue = inputValue?.length > 40 ? `${inputValue.substring(0, 40)}...` : inputValue;
    const inputId = event?.target?.id;
    const editorInstance = editorRef.current?.editor;
    if (!editorInstance) return;
    const skipDomRebuild = isEditorInteractionActive(editorInstance);
    let editorContent = editorInstance?.html?.get();
    const safeInputId = escapeRegExp(inputId);
    const safeTruncatedValue = escapeHtmlAttribute(truncatedValue);
    const inputRegex = new RegExp(`<input[^>]*?id=["']${safeInputId}["'][^>]*?value=["'][^"']*["']`, "g");
    editorContent = editorContent?.replace(inputRegex, (inputMatch) => {
      return inputMatch.replace(/value=["'][^"']*["']/, `value="${safeTruncatedValue}"`);
    });
    if (!skipDomRebuild) {
      editorInstance?.html?.set(editorContent);
      setEditorContent(prevState => ({ ...prevState, innerHTML: editorContent }));
    } else {
      const liveInput = document.getElementById(inputId);
      if (liveInput) {
        liveInput.setAttribute("value", truncatedValue);
        liveInput.setAttribute("title", truncatedValue);
      }
    }
    const utcTime = await GetUTCTime();

    changedDropdownIdsRef.current.add(inputId);

    // Get the current editor content before state update
    const currentEditorContent = editorInstance?.html?.get();

    // Compute the updated dropdown list up front so the state updater stays pure
    // (no async dispatch / side effects inside it — React may invoke updaters more
    // than once, which would cause duplicate save dispatches).
    const currentDropdowns = dropdownsParam || introductoryDropdownsRef.current || [];
    let updatedDropdowns = [...currentDropdowns];
    const dropdownIndex = updatedDropdowns.findIndex(
      (dropdown) => dropdown?.dropdown_uuid === inputId
    );
    if (dropdownIndex !== -1) {
      updatedDropdowns[dropdownIndex] = {
        ...updatedDropdowns[dropdownIndex],
        selected_value: inputValue,
        updated_at: utcTime
      };
    } else {
      updatedDropdowns.push({
        dropdown_uuid: inputId,
        name: "",
        selected_value: inputValue,
        dropdowns_values: [],
        updated_at: utcTime
      });
    }
    const changedDropdown = dropdownIndex !== -1
      ? updatedDropdowns[dropdownIndex]
      : updatedDropdowns[updatedDropdowns.length - 1];

    setIntroductoryDropdowns(updatedDropdowns);
    // Pass the editor content to ensure text is included with dropdown changes
    handleIntroSave([changedDropdown], null, currentEditorContent, false);
    setHasChanges(false);
    setIsFocused(false);
  }, [editorRef, handleIntroSave, isEditorInteractionActive]);

  useEffect(() => {
    handleChangeDropdownRef.current = handleChangeDropdown;
  }, [handleChangeDropdown]);

  // Use useEffect to properly attach event listeners and avoid stale closures
  useEffect(() => {
    const introDropElements = document.querySelectorAll(".intro-cl-dropdown");
    const changeHandlers = [];
    introDropElements.forEach((element) => {
      if (element) {
        const changeHandler = (event) => {
          // Pass null to use functional state update inside handleChangeDropdown
          handleChangeDropdown(event, null);
        };
        element.addEventListener("change", changeHandler);
        changeHandlers.push({ element, handler: changeHandler });
      }
    });
    return () => {
      changeHandlers.forEach(({ element, handler }) => {
        element.removeEventListener("change", handler);
      });
    };
  }, [activeCategoryData, editorRef, handleChangeDropdown]);

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (hasChanges) {
        event.preventDefault();
        event.returnValue = "";
      }
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasChanges]);

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isClickOutside =
        containerRef.current && !containerRef.current.contains(event.target) &&
        !dialogRef?.current?.contains(event.target) &&
        event.target.id !== "add-dropdown";
      if (hasChanges && (isClickOutside || event?.target?.innerText?.toLowerCase()?.includes("media"))) {
        setHasChanges(false);
        saveIntroText();
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [hasChanges, editorContent]);

  useEffect(() => {
    const editorInstance = editorRef?.current?.editor;
    if (editorInstance && prevData) {
      const contentArea = editorInstance?.$el?.get(0);
      if (!contentArea) return;
      const changeDropdown = (event) => {
        if (event.target?.closest?.(".froala-dynamic-input-wrapper")) return;
        if (!event.target?.classList?.contains("froala-dropdown-input")) return;
        // Pass null to use functional state update inside handleChangeDropdown
        handleChangeDropdown(event, null);
      };
      contentArea.removeEventListener("change", changeDropdown);
      contentArea.addEventListener("change", changeDropdown);
      return () => {
        contentArea.removeEventListener("change", changeDropdown);
      };
    }
  }, [editorRef, prevData, handleChangeDropdown]);

  useEffect(() => {
    const changeDropdown = (event) => {
      // Pass null to use functional state update inside handleChangeDropdown
      handleChangeDropdown(event, null);
    };
    document.removeEventListener("changeValue", changeDropdown);
    document.addEventListener("changeValue", changeDropdown);
    return () => {
      document.removeEventListener("changeValue", changeDropdown);
    };
  }, [editorRef, prevData, handleChangeDropdown]);

  useEffect(() => {
    if (storeData.inspectionData) {
      setInspectionResponse(storeData);
    }
  }, [storeData.inspectionData]);

  const handleDropdownList = (name, value, type, changedUuid) => {
    if (name === "intro-text-editor") {
      const prevDropdownCount = introductoryDropdownsRef.current?.length ?? 0;
      const newDropdownCount = value?.length ?? 0;

      setIntroductoryDropdowns(value);
      setIsCopy(false);

      if (changedUuid) {
        changedDropdownIdsRef.current.add(changedUuid);
        const changedDropdown = value?.find(d => d?.dropdown_uuid === changedUuid);
        handleIntroSave(changedDropdown ? [changedDropdown] : undefined, type, null);
      } else if (type === "text-only") {
        handleIntroSave(null);
      } else if (prevDropdownCount > newDropdownCount) {
        // Dropdown was deleted - save the updated text and empty dropdowns list
        const currentEditorContent = editorRef?.current?.editor?.html?.get();
        handleIntroSave(value?.length > 0 ? value : null, null, currentEditorContent);
      }
    }
  }

  return (
    <>
      {showRMLpopup && <RMLpopup showRMLpopup={showRMLpopup} setShowRMLpopup={setShowRMLpopup} templateId={templateId} categoryId={categoryId} />}
      <Grid container className="input-controll" ref={containerRef}>
        <Grid item xs={12} sm={12} sx={{ padding: "8px 46px 0px 46px" }}>
          <div>
            <FroalaEditorComponent
              copy={isCopy}
              showAI={false}
              commentData={activeCategoryData}
              editorData={editorContent}
              setEditorContent={setEditorContent}
              editor={editorRef}
              id={"intro-text-editor"}
              onChange={handleChange}
              froalaConfig={froalaConfig}
              handleDropdownList={handleDropdownList}
              dialogRef={dialogRef}
              templateId={templateId}
              isFocused={isFocused}
              setIsFocused={setIsFocused}
              setHasChanges={setHasChanges}
              setIsButtonAdded={setIsButtonAdded}
              onLocalEditStart={markIntroLocalEdit}
              handleIntroSave={handleIntroSave}
              isEdit={true}
              hasChanges={hasChanges}
              filterTagList={tag}
              categoryId={categoryId}
              introductoryTextMedia={introTextMedia}
            />
          </div >
        </Grid >
        {activeCategoryData?.is_inspection_details === 2 || templateData?.is_narrative_template === 0 ? "" : <div>
          <Grid
            container
            spacing={1}
            className="container"
            sx={{
              width: (() => {
                const visibleItems = introTextMedia?.filter((item) => item.is_deleted === 0)?.length;
                if (visibleItems === 3) {
                  return "calc(100% + 376px) !important";
                } else if (visibleItems === 2) {
                  return "calc(100% + 600px) !important";
                } else if (visibleItems === 4) {
                  return "calc(100% + 145px) !important";
                } else {
                  return "calc(100% + 20px)";
                }
              })(),
            }}
            onClick={(e) => e?.stopPropagation()}
          >
            <Grid item xs={12} className="rml_popup_heading">
              <span className="intro_text_media_title">Media</span>
            </Grid>
            {introTextMedia !== undefined && introTextMedia?.filter(e => e?.is_deleted !== 1)?.length === 0 && (<Grid sx={{ m: "10px" }} item xs={12} sm={6} md={4} lg={introTextMedia?.filter((item) => item.is_deleted === 0)?.length === 1 ? 7 : 2.4}>
              <Typography
                className="add-media-box-intro-text"
                id={"add_media_box"}
                onClick={(e) => {
                  setShowRMLpopup(true);
                }}
              >
                <input style={{ display: "none" }} />
                <div style={{ marginTop: "35px" }}>
                  <AddCircleIcon />
                </div>
                <div style={{ textDecoration: "underline", color: "#4282e2", fontSize: "14px", fontWeight: "600" }}>Click to add media</div>
              </Typography>
            </Grid>)}
          </Grid>
        </div>}
      </Grid >
      <div >
        {introTextMedia !== undefined && introTextMedia?.length !== 0 && (
          <IntroTextMedia
            introTextMedia={introTextMedia}
            inspectionResponse={inspectionResponse}
            templateId={templateId}
            setShowRMLpopup={setShowRMLpopup}
            categoryId={categoryId}
            categoryUuid={activeCategoryData?.uuid}
            categoryData={activeCategoryData}
          />
        )}
      </div>
    </>
  );
};

export default AddIntroText;
